import React, { useState, useEffect } from 'react';
import { ControlLabel, FormGroup, InputGroup, DropdownButton, MenuItem } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { onChangeRatesValue, onBlurValidateRate, generatePriceWithType } from '../../helpers';

const RateInput = ({ inputLabel, refInput, value, name, valueType, onChangeType, onChangeValue, currency, originalValue, dropup, config }) => {
  const [prices, setPrices] = useState(generatePriceWithType(value, valueType, originalValue, config));
  const [inputValue, setInputValue] = useState(value);
  const [selectedRateType, setSelectedRateType] = useState({ key: '', symbol: '' });

  const onChange = (e) => {
    onChangeRatesValue(e.target.value, setInputValue, valueType, setPrices);
  };

  const onSelectRateType = (type) => {
    if (type !== selectedRateType.symbol) {
      setSelectedRateType({ key: type, symbol: type === '0' ? currency.currency_symbol || currency.currency_code : '%' });
      onChangeType && onChangeType(type, type === '0' ? prices.custom_price : prices.custom_percent);
    }
  };

  useEffect(() => {
    setInputValue(value);
    setPrices(generatePriceWithType(value, valueType, originalValue, config));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  useEffect(() => {
    onChangeValue && onChangeValue(valueType === '0' ? prices.custom_price : prices.custom_percent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue]);

  useEffect(() => {
    setPrices(generatePriceWithType(value, valueType, originalValue, config));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSelectedRateType({ key: valueType, symbol: valueType === '0' ? currency.currency_symbol || currency.currency_code : '%' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valueType]);

  return (
    <FormGroup className="mb-0 edit-rate">
      {inputLabel && <ControlLabel>{inputLabel}</ControlLabel>}
      <InputGroup>
        <input
          type="text"
          name={name}
          className="form-control"
          ref={refInput}
          value={inputValue}
          onChange={onChange}
          autoComplete="off"
          onBlur={(e) => onBlurValidateRate(e, setInputValue, valueType, setPrices)}
          onKeyPress={(e) => {
            if (e.which === 13 || e.keyCode === 13) {
              e.preventDefault();
            }
          }}
        />
        <DropdownButton
          onSelect={onSelectRateType}
          pullRight
          componentClass={InputGroup.Button}
          id="input-dropdown-addon"
          title={selectedRateType.symbol}
          dropup={dropup}
        >
          <MenuItem eventKey="1">% (percent)</MenuItem>
          <MenuItem eventKey="0">
            {!currency.currency_symbol ? `${currency.currency_code}` : `${currency.currency_symbol} (${currency.currency_code})`}
          </MenuItem>
        </DropdownButton>
      </InputGroup>
    </FormGroup>
  );
};

RateInput.propTypes = {
  inputLabel: PropTypes.string,
  refInput: PropTypes.any,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  valueType: PropTypes.string,
  onChangeType: PropTypes.func,
  onChangeValue: PropTypes.func,
  currency: PropTypes.object,
  originalValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dropup: PropTypes.bool,
  config: PropTypes.object,
};

RateInput.defaultProps = {
  valueType: '0',
  dropup: false,
};

export default RateInput;
